import { createReferral } from '@/utils/api';
import i18n from '@/utils/i18n';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    invites: [{ Name: '', Email: '' }],
    referStatus: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateReferStatus(state, row) {
    state.referStatus = {
      ...state.referStatus,
      ...row,
    };
  },
  addRow(state) {
    state.invites.push({ Name: '', Email: '' });
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  removeReferral(state, index) {
    state.invites = state.invites.filter((_, i) => i !== index);
  },
};

const actions = {
  tryCreateReferral({ commit, state }) {
    const invites = state.invites
      .filter(r => r.Email && r.Name)
      .map(r => ({
        Email: r.Email,
        Name: r.Name,
      }));

    if (invites.length === 0) {
      commit('updateReferStatus', { error: i18n.t('ReferView.FillAllInputs') });
      return;
    }

    for (let i = 0; i < invites.length; i++) {
      const invite = invites[i];
      if (invite.Email.indexOf('@') == -1 || invite.Email.indexOf('.') == -1) {
        commit('updateReferStatus', {
          error: i18n.t('ReferView.EmailInvalid'),
        });
        return;
      }
    }

    commit('updateReferStatus', {
      loading: true,
      success: false,
      error: false,
    });
    setTimeout(() => {
      createReferral(invites).then(r => {
        if (r.data.IsSuccess) {
          commit('updateReferStatus', { success: i18n.t('ReferView.Success') });
          commit('updateReferStatus', { error: false });
        } else {
          commit('updateReferStatus', { success: false });
          commit('updateReferStatus', { error: i18n.t('ReferView.Error') });
        }
        commit('updateReferStatus', { loading: false });
        setTimeout(() => {
          commit('resetState', {});
        }, 3000);
      });
    }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
